module.exports = __webpack_public_path__ + "img/edit2.99dd961b.svg";